import { DependencyList, useEffect } from "react";
import { useScene } from "./use-scene";

export const useOnSceneSkipped = (
  fn: () => boolean,
  deps: DependencyList = []
) => {
  const scene = useScene();

  useEffect(() => {
    const off = scene.on("skip", fn);

    return off;
  }, [scene, ...deps]);
};
